import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { userFetchIfNeeded } from './../store/user/actions';
import { settingsFetchIfNeeded } from './../store/settings/actions';
import { notificationFetchIfNeeded } from './../store/notification/actions';
import { ordersFindSetSorting } from './../store/ordersFind/actions';
import { setToken } from './../utils/tokenStorage';

class DataPreload extends Component {
    componentDidMount() {
        const { loadData, location, history } = this.props;
        const idx = location.search.indexOf('?t=');
        if (idx !== 0) {
            loadData();
            return;
        }
        const token = location.search.substr(idx + 3).replace('Bearer%20', 'Bearer ');
        setToken(token);
        loadData();
        history.replace(location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.props.loadNotifications();
        }
        if (prevProps.userLoading && !this.props.userLoading) {
            if (this.props.userDe) {
                this.props.ordersSetSortingDefault();
            }
        }
    }

    render() {
        const { isLoading, id } = this.props;
        return (
            <div id={id}>
                {!isLoading && this.props.children}
                {!!isLoading &&
                    <div className="preloading">
                        <p>Loading</p>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    const isLoading =
        store.user.isFetching ||
        store.user.didInvalidate ||
        store.settings.didInvalidate ||
        store.settings.isFetching;

    const userLoading = store.user.isFetching || store.user.didInvalidate;
    const userDe = !userLoading && store.user && store.user.profile_type === 'D';

    return { isLoading, userLoading, userDe };
};

const mapDispatchToProps = dispatch => {
    return {
        loadData: () => {
            dispatch(userFetchIfNeeded());
            dispatch(notificationFetchIfNeeded());
            dispatch(settingsFetchIfNeeded());
        },
        loadNotifications: () => dispatch(notificationFetchIfNeeded()),
        ordersSetSortingDefault: () => {
            dispatch(ordersFindSetSorting('final_deadline'));
            dispatch(ordersFindSetSorting('final_deadline'));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataPreload));



// WEBPACK FOOTER //
// ./src/components/DataPreload.js